"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateSplicer = void 0;
function dateSplicer(date) {
    var result = {
        year: -1,
        month: -1,
        day: -1,
        hour: 0,
        minute: 0,
        second: 0,
        miliSecond: 0,
    };
    if (!date.match(/[0-9]+/g)) {
        return result;
    }
    // get data from input
    var _a = __read(date.match(/[0-9]+/g), 7), year = _a[0], month = _a[1], day = _a[2], hour = _a[3], minute = _a[4], second = _a[5], miliSecond = _a[6];
    /**
     * without hour, minute, second and  miliSecond you can calculate date
     * but without year, month and day it is NOT possible
     */
    result.year = isNaN(Number(year)) ? -1 : Number(year);
    result.month = isNaN(Number(month)) ? -1 : Number(month);
    result.day = isNaN(Number(day)) ? -1 : Number(day);
    result.hour = isNaN(Number(hour)) ? 0 : Number(hour);
    result.minute = isNaN(Number(minute)) ? 0 : Number(minute);
    result.second = isNaN(Number(second)) ? 0 : Number(second);
    result.miliSecond = isNaN(Number(miliSecond)) ? 0 : Number(miliSecond);
    return result;
}
exports.dateSplicer = dateSplicer;
